
import { IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular';
import { ErrorHandler, NgModule } from '@angular/core';
import { MyApp } from './app.component';
import { BrowserModule } from '@angular/platform-browser';
import { CommonModule } from "@angular/common";

import { AngularFireModule } from 'angularfire2';
// import { AngularFireDatabaseModule } from 'angularfire2/database';
import { AngularFireAuthModule } from 'angularfire2/auth';
// import { HttpModule } from '@angular/http';
// import { HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
// import { AngularFirestoreModule } from 'angularfire2/firestore';
import { IonicStorageModule } from '@ionic/storage';
import { AgmCoreModule } from '@agm/core';
// import { FormsModule } from '@angular/forms';
// import { AngularFireStorageModule } from 'angularfire2/storage';
import * as firebase from 'firebase/app'
// import { LoadingProvider } from '../providers/loading/loading';
// import { UserData } from '../providers/loading/userData';
// import { EnvDataService } from './services/env-data-service';
import 'firebase/firestore';
// import { HomeService } from './services/home-service';
import {AdminDashboardPageModule} from '../pages/admin-dashboard/admin-dashboard.module';

// dev

// const firebaseConfig = {
//   apiKey: "AIzaSyB4-JhfSUr31EyqUid4UuB2tKVgDYSjx4I",
//   authDomain: "loan-management-sandbox.firebaseapp.com",
//   databaseURL: "https://loan-management-sandbox.firebaseio.com",
//   projectId: "loan-management-sandbox",
//   storageBucket: "loan-management-sandbox.appspot.com",
//   messagingSenderId: "307515620597",
//   appId: "1:307515620597:web:c503eaaf787d9e90"
// };

// firebase use product ID
// prod

const firebaseConfig = {
  apiKey: "AIzaSyCEhgI_WqnidtPHsKO-GrY6jw0L4mrnPcg",
  authDomain: "sync-afy-dev-sandbox.firebaseapp.com",
  databaseURL: "https://sync-afy-dev-sandbox.firebaseio.com",
  projectId: "sync-afy-dev-sandbox",
  storageBucket: "sync-afy-dev-sandbox.appspot.com",
  messagingSenderId: "191692571695",
  appId: "1:191692571695:web:3e5b388b093e8091fbf2da",
  measurementId: "G-MXQT70K74Q"
};

// export const firebaseConfig = {
//     apiKey: "AIzaSyCEhgI_WqnidtPHsKO-GrY6jw0L4mrnPcg",
//     authDomain: "sync-afy-dev-sandbox.firebaseapp.com",
//     databaseURL: "https://sync-afy-dev-sandbox.firebaseio.com",
//     projectId: "sync-afy-dev-sandbox",
//     storageBucket: "sync-afy-dev-sandbox.appspot.com",
//     messagingSenderId: "191692571695",
//     appId: "1:191692571695:web:3e5b388b093e8091fbf2da",
//   };

export default !firebase.apps.length
  ? firebase.initializeApp(firebaseConfig).firestore()
  : firebase.app().firestore();
  firebase.auth().setPersistence(firebase.auth.Auth.Persistence.SESSION)
  
@NgModule({
  declarations: [
    MyApp,
  ],
  imports: [
    BrowserModule,
    CommonModule,
    // FormsModule,
    IonicStorageModule.forRoot(),
    // HttpClientModule,
    BrowserAnimationsModule,
    AngularFireModule.initializeApp(firebaseConfig),
    // AngularFirestoreModule,
    // AngularFireStorageModule,
    // AngularFireDatabaseModule,
    AngularFireAuthModule,
    // HttpModule,
    AgmCoreModule.forRoot(  {
      apiKey: 'AIzaSyAMGFqXwtS202SSbWmhaMADSDSdVPu8AQk',
	   libraries: ["places"]
    }),
  IonicModule.forRoot(MyApp, {}, ),
  AdminDashboardPageModule
  ],
  entryComponents: [
    MyApp,
  ],
  bootstrap: [IonicApp],
  // providers: [
  //   {provide: ErrorHandler, useClass: IonicErrorHandler},
  //   LoadingProvider,
  //   Storage,
  //   UserData,
  //   EnvDataService,
  //   HomeService
  // ]
})
export class AppModule {}


// WEBPACK FOOTER //
// ./src/app/app.module.ts